app.factory('attachmentFileModel', ['$rootScope', '$location', 'baseModel', 'config', 'attachmentFileService',
    function($rootScope, $location, baseModel, config, attachmentFileService) {

        function AttachmentFileModel() {
            this.download = function(id) {
                var fileLocation = config.API_URL + '/attachmentFiles/' + id  + '/download';
                window.open(fileLocation, '_blank');
            };

        }

        return new AttachmentFileModel();
    }
]);
